import http from '../plugins/axios'

export const getAllCourierList = async (params) => {
  try {
    const response = await http.get(`/api/v2/couriers`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}